import { Easing, Platform, StyleSheet } from "react-native"

// Static require map for Rive files - Metro bundler requires static require() for asset resolution
/* eslint-disable @typescript-eslint/no-require-imports */
export const riveFileMap: Record<string, any> = {
  rive_0: require("../../resources/rive_0.riv"),
  rive_1: require("../../resources/rive_1.riv"),
  rive_2: require("../../resources/rive_2.riv"),
  rive_3: require("../../resources/rive_3.riv"),
  rive_4: require("../../resources/rive_4.riv"),
  rive_5: require("../../resources/rive_5.riv"),
  rive_6: require("../../resources/rive_6.riv"),
  rive_7: require("../../resources/rive_7.riv"),
  rive_8: require("../../resources/rive_8.riv"),
  rive_9: require("../../resources/rive_9.riv"),
  rive_10: require("../../resources/rive_10.riv"),
  rive_11: require("../../resources/rive_11.riv"),
  rive_12: require("../../resources/rive_12.riv"),
  rive_13: require("../../resources/rive_13.riv"),
  rive_14: require("../../resources/rive_14.riv"),
  rive_15: require("../../resources/rive_15.riv"),
  rive_16: require("../../resources/rive_16.riv"),
  rive_17: require("../../resources/rive_17.riv"),
  rive_18: require("../../resources/rive_18.riv"),
  rive_19: require("../../resources/rive_19.riv"),
  rive_20: require("../../resources/rive_20.riv"),
  rive_21: require("../../resources/rive_21.riv"),
  rive_22: require("../../resources/rive_22.riv"),
  rive_23: require("../../resources/rive_23.riv"),
  rive_24: require("../../resources/rive_24.riv"),
  rive_25: require("../../resources/rive_25.riv"),
  rive_26: require("../../resources/rive_26.riv"),
  rive_27: require("../../resources/rive_27.riv"),
  rive_28: require("../../resources/rive_28.riv"),
  rive_29: require("../../resources/rive_29.riv"),
  rive_30: require("../../resources/rive_30.riv"),
  rive_31: require("../../resources/rive_31.riv"),
  rive_32: require("../../resources/rive_32.riv"),
  rive_33: require("../../resources/rive_33.riv"),
  rive_34: require("../../resources/rive_34.riv"),
  rive_35: require("../../resources/rive_35.riv"),
  rive_36: require("../../resources/rive_36.riv"),
  rive_37: require("../../resources/rive_37.riv"),
  rive_38: require("../../resources/rive_38.riv"),
  rive_39: require("../../resources/rive_39.riv"),
  rive_40: require("../../resources/rive_40.riv"),
  rive_41: require("../../resources/rive_41.riv"),
  rive_42: require("../../resources/rive_42.riv"),
  rive_43: require("../../resources/rive_43.riv"),
}
/* eslint-enable @typescript-eslint/no-require-imports */

// Shared resource name generation logic
export const getRiveResourceName = (
  riveMskAvatarId: number | null | undefined,
): string | undefined => {
  if (riveMskAvatarId === null || riveMskAvatarId === undefined || riveMskAvatarId === -1) {
    return undefined
  }
  return `rive_${riveMskAvatarId}`
}

// Shared container styles logic
export const getContainerStyles = (isWeb: boolean = Platform.OS === "web") => ({
  container: {
    display: "flex" as const,
    flexDirection: "row" as const,
    flex: 1,
    overflow: "hidden" as const,
    width: "100%" as const,
    ...(isWeb ? { minHeight: 400, maxHeight: 400 } : { height: 250, flex: 0 }),
  },
  leftPanel: {
    alignItems: "center" as const,
    ...(isWeb ? {} : { height: "100%" as const }),
  },
  rightPanel: {
    alignItems: "center" as const,
    ...(isWeb ? { width: "50%" as const } : { height: "100%" as const }),
  },
})

// Shared CSS Styles
export const sharedStyles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    width: "100%",
  },
  leftPanel: {
    justifyContent: "center",
    alignItems: "center",
  },
  rightPanel: {
    justifyContent: "center",
    alignItems: "center",
  },
})

// Shared animation configuration
export const getAnimationConfig = () => ({
  duration: 500,
  easing: Easing.inOut(Easing.ease),
  useNativeDriver: false,
})
